import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GoogleButton from "react-google-button";
import { onAuthStateChanged } from "firebase/auth";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import { useUserAuth } from "../../../contextApi/backlink/useAuthContext";
import favicon from "../Assets/Favicon.png";
import { auth2 } from "../../../firebase";
import { Helmet } from "react-helmet";
import "./style.css";
import Logo from "../Assets/Logo";

const BacklinkLogin = ({ page }) => {
  const pageReplace = page === "indexme" ? "indexme" : "backlink";
  const { googleSignIn, logIn, signUp, resetPassword } = useUserAuth();
  // console.log({ page });
  const location = useLocation();
  const [authentic, setAuthentic] = useState(true);
  const [open, setOpen] = useState(false);
  const [resetPass, setResetPass] = useState(false);
  const [signup, setSignup] = useState(true);
  const navigate = useNavigate();
  const inref1 = useRef();
  const inref2 = useRef();
  const inref3 = useRef();

  useEffect(() => {
    onAuthStateChanged(auth2, async (current) => {
      if (current) {
        navigate(
          location?.state && location.state.location
            ? location.state.location
            : page === "indexme"
            ? `/${pageReplace}`
            : `/${pageReplace}/list`,
        );
        return;
      } else setAuthentic(false);
    });
  }, []);

  const redirectAfterLogin = () => {
    const gotoRoute = localStorage.getItem("gotoRoute");
    // console.log({gotoRoute: gotoRoute});
    if (gotoRoute) {
      localStorage.removeItem("gotoRoute");
      const pathname = `/${pageReplace}${gotoRoute.split("?")[0]}`;
      const search = gotoRoute.split("?")[1];
      const navigateParams = { pathname };
      if (search) navigateParams.search = `?${search}`;
      // console.log({navigateParams});
      return navigate(navigateParams);
    }
    navigate(page === "indexme" ? "/indexme" : "/backlink");
  };

  const AuthBtn = ({ text, clickFn }) => {
    return (
      <div className="mt-3 signUpContainer" onClick={clickFn}>
        <div className="mailIconContinaer">
          <MailOutlinedIcon
            color="action"
            style={{ width: "20px", height: "20px" }}
          />
        </div>
        <div className="signUpTitle">{text}</div>
      </div>
    );
  };

  const signUpWithEmail = async (e) => {
    e.preventDefault();
    const email = inref1.current.value;
    const password = inref2.current.value;
    const name = inref3.current.value;

    if (!name || !email || !password) {
      window.sweet({
        title: "Error",
        text: "Name, Email and password can not be empty",
        icon: "error",
      });
      return;
    }

    const { error, user } = await signUp(name, email, password);
    if (error) {
      window.sweet({
        title: "Error",
        text: error?.includes("email-already-in-use")
          ? "Email already registered"
          : error,
        icon: "error",
      });
    } else {
      navigate(`/${pageReplace}`);
      window.sweet({
        title: "Account Created",
        text: "Please verify your email",
        icon: "success",
      });
    }
  };

  const signWithEmail = async (e) => {
    e.preventDefault();

    const email = inref1.current.value;
    const password = inref2.current.value;

    // add email vertification
    if (email && password) {
      const { error, user } = await logIn(email, password);
      console.log({ error, user });
      if (error?.includes("user-not-found")) {
        window.sweet({
          title: "Error",
          text: "User not found",
          icon: "error",
        });
      } else if (error?.includes("wrong-password")) {
        window.sweet({
          title: "Error",
          text: "Wrong Password",
          icon: "error",
        });
      } else if (error?.includes("verify your email")) {
        window.sweet({
          title: "Error",
          text: "Please verify your email",
          icon: "error",
        });
      } else if (error?.includes("Signin with google")) {
        window.sweet({
          title: "Error",
          text: "Please Signin with google",
          icon: "error",
        });
      } else {
        redirectAfterLogin();
      }
    } else {
      window.sweet({
        title: "Error",
        text: "Email and password can not be empty",
        icon: "error",
      });
    }
  };

  const forgotPassword = async () => {
    var re = /\S+@\S+\.\S+/;
    var valid = re.test(inref1.current.value);
    if (!valid) {
      window.sweet({
        title: "Error",
        text: "Please enter a valid email.",
        icon: "error",
      });
      return;
    }
    const email = inref1.current.value;
    await resetPassword(email);
  };

  const title =
    page === "indexme" ? "Setup - Index My Site" : "Backlink monitor App";
  const description =
    page === "indexme"
      ? "Use Index My Site to check if the URLs in your sitemap are indexed or not. We integrate directly with Google Search Console for the most accurate data. If any of the pages are not indexed, we send Request Indexing calls through Google Search Console instead of doing it through pinging. This is a modern way of doing things instead of the old school way. Ensure that your webpages reach Google to fetch you that SEO traffic"
      : "Build backlinks effortlessly from our curated backlink marketplace. ";
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:url" content="https://app.linkly.digital" />
        <meta property="og:title" content={title} />
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
        <meta property="og:description" content={description} />
        <meta
          name="twitter:card"
          content={page === "indexme" ? "/indexmeicon.svg" : "/og_backLink.jpg"}
        />
        {/* <meta property="og:image" key="og:image" content={"/og_backLink.jpg"} /> */}
      </Helmet>
      {!authentic ? (
        <div style={{ display: "flex", height: "100vh" }}>
          <div
            className="d-none d-md-flex col-md-4 col-lg-6 bg-image"
            style={{
              backgroundImage: "url(../backLink_SignUp.png)",
              backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          ></div>
          <div className="align-items-center py-2 loginBg login">
            <div className="container">
              <div className="row">
                <div className="mx-auto text-center align-items-center">
                  <div className="container d-flex  flex-row  justify-content-center">
                    {page !== "indexme" ? (
                      <>
                        <Logo />
                        <h1 className="text-center loginTitle">
                          Backlink{" "}
                          {window.location.host === "app.backlinkmonitor.co"
                            ? "Monitor"
                            : "Checker"}
                        </h1>
                      </>
                    ) : (
                      <img
                        src="/indexmeicon.svg"
                        alt=""
                        className="indexmeicon"
                      />
                    )}
                    &nbsp; &nbsp;
                  </div>
                  <p
                    style={{ fontSize: "16px", color: "#26456C" }}
                    className="text-center ml-3 subLoginTitle"
                  >
                    {page === "indexme"
                      ? "Quickly index your site pages"
                      : "Never Fear Losing a Backlink"}
                  </p>
                  {page === "indexme" ? (
                    <h6 className="text-center subLoginTitleDes">
                      "Request Indexing" through Google Search Console
                    </h6>
                  ) : (
                    <h6 className="text-center subLoginTitleDes">
                      Monitor your backlinks
                      <br /> Get notified if link, rel tag, anchor change
                    </h6>
                  )}

                  <h3 style={{ fontFamily: "sans-serif" }}>
                    {resetPass ? "Reset" : signup ? "Sign Up" : "Login"}
                  </h3>
                  {!resetPass && (
                    <p>
                      {signup
                        ? "Already have an account ? "
                        : "Don`t have an account ? "}
                      <span
                        className="forgetPasswordInLinkly"
                        onClick={() => setSignup((prev) => !prev)}
                        style={{ color: "blue" }}
                      >
                        {signup ? "Login" : "Sign Up"}
                      </span>
                    </p>
                  )}
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    {
                      <>
                        {!resetPass && signup && (
                          <input
                            className="mt-2 mb-3 input"
                            ref={inref3}
                            placeholder="Enter Name"
                          />
                        )}
                        <input
                          type="email"
                          className="input"
                          ref={inref1}
                          placeholder="Enter Email"
                        />

                        {!resetPass && (
                          <input
                            type="password"
                            className="mt-2 input"
                            ref={inref2}
                            placeholder="Enter Password"
                          />
                        )}
                        {!signup && !resetPass && (
                          <div
                            className="forgetPasswordInLinkly mt-2"
                            onClick={() => setResetPass(true)}
                            style={{
                              color: "blue",
                              fontSize: "12px",
                              marginLeft: "20%",
                            }}
                          >
                            Forgot Password?
                          </div>
                        )}
                      </>
                    }

                    {!resetPass &&
                      (signup ? (
                        <AuthBtn
                          text={"Sign Up With Email"}
                          clickFn={signUpWithEmail}
                        />
                      ) : (
                        <AuthBtn
                          text={"Sign In with Email"}
                          clickFn={signWithEmail}
                        />
                      ))}
                    {resetPass && (
                      <button
                        onClick={() => forgotPassword()}
                        className="resetPassButton"
                      >
                        Reset Password
                      </button>
                    )}

                    {!resetPass && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "black",
                        }}
                        className="mt-2"
                      >
                        <hr
                          style={{
                            flex: "1",
                            width: "100px",
                          }}
                        />
                        <span style={{ margin: "0 10px" }}>Or</span>
                        <hr style={{ flex: "1", width: "100px" }} />
                      </div>
                    )}

                    {!resetPass && (
                      <GoogleButton
                        className="g-btn mt-2 google-btn"
                        type="dark"
                        onClick={(e) => googleSignIn(e, redirectAfterLogin)}
                        label="Signup/Login with Google"
                      />
                    )}

                    {resetPass && (
                      <div
                        className="forgotPassword"
                        onClick={() => {
                          setResetPass(false);
                          setSignup(true);
                        }}
                      >
                        Back To Sign Up
                      </div>
                    )}
                    <div className="terms">
                      <p>By continuing you agree to our</p>
                      <p
                        style={{
                          marginTop: "-20px",
                        }}
                      >
                        <a
                          href={
                            page === "indexme"
                              ? "https://www.indexmysite.co/terms-and-conditions"
                              : "https://www.backlinkchecker.info/terms-and-conditions"
                          }
                        >
                          Terms
                        </a>{" "}
                        &{" "}
                        <a
                          href={
                            page === "indexme"
                              ? "https://www.indexmysite.co/privacy-policy"
                              : "https://www.backlinkchecker.info/privacy-policy"
                          }
                        >
                          Privacy Policy
                        </a>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <img alt="" src="icons/loading.gif" />
        </div>
      )}
    </>
  );
};
// REACT_APP_HOST =' https://linkly-backend-stg.herokuapp.com'
export default BacklinkLogin;

{
  /* <svg class="MuiSvgIcon-root MuiSvgIcon-colorAction MuiSvgIcon-fontSizeMedium css-11pbyhm-MuiSvgIcon-root" focusable="false" aria-hidden="true" 
viewBox="0 0 46 46" data-testid="MailOutlinedIcon" 
style="user-select: auto; width: 48px; height: 48px;">
  <path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0-8 4.99L4 6h16zm0 12H4V8l8 5 8-5v10z" style="user-select: auto;"></path>
  </svg>
</svg>

<svg
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  width="46px"
  height="46px"
  viewBox="0 0 46 46"
  style="width: 48px; height: 48px; display: block; user-select: auto;"
>
 
</svg>; */
}
